import { Alert, Chip } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteUploads } from "../../services/stacks";
import DOMPurify from "dompurify";
import MarkdownIt from "markdown-it/index.js";
// import { useEffect } from "react";

const AttachmentPreview = ({ attachmentUrl, thumbnailUrl, setThumbnailUrl, setAttachmentUrl, setThumbnailBtn, setAttachmentBtn }) => {

    const mdParser = new MarkdownIt();
    const markUpPreview = (text) => {
        const rawHtml = mdParser.render(text || '');
        const cleanHtml = DOMPurify.sanitize(rawHtml);
        return { __html: cleanHtml };
    };

    function deleteAttachment() {
        const { at_state, at_name } = attachmentUrl;
        if (at_state) {
            deleteUploads(at_name).then(({ success }) => {
                if (success) {
                    setAttachmentUrl({ at_url: '', at_file: null, at_name: '', at_state: false, type: '' });
                    setAttachmentBtn(false);
                    setThumbnailBtn(true);
                    if (thumbnailUrl.th_state) {
                        deleteUploads(thumbnailUrl.th_name).then(({ success }) => {
                            if (success) {
                                setThumbnailUrl({ th_url: '', th_file: null, th_name: '', th_state: false, type: '' });
                            }
                        })
                    }
                }
            })

        }
    }

    function deleteThumbnail() {
        const { th_state, th_name } = thumbnailUrl;
        deleteUploads(th_name).then(({ success }) => {
            if (success) {
                if (th_state) {
                    setThumbnailUrl({ th_url: '', th_file: null, th_name: '', th_state: false, type: '' });
                    setThumbnailBtn(false);
                }
            }
        })


    }

    return (
        <div id="attachment-preview" className='createChimeStyler'>
            {console.log('Hello hgajkj', (thumbnailUrl.th_state && (attachmentUrl.type !== "video" && attachmentUrl.type !== 'md')))}
            {(thumbnailUrl.th_state && (attachmentUrl.type !== "video" && attachmentUrl.type !== 'md')) && (
                <img
                    id="image-thumbnail"
                    className="img"
                    src={thumbnailUrl.th_url}
                    alt="preview"
                    loading="quick"
                    gaiaStorageName={thumbnailUrl.th_name}
                />
            )}

            {attachmentUrl.type === "image" &&
                < img id="image-attachment" className='img' src={attachmentUrl.at_url} alt='preview' loading="quick" gaiaStorageName={attachmentUrl.at_name} />
            }

            {attachmentUrl.at_state &&
                <>
                    {attachmentUrl.type === "audio" &&
                        <audio id="audio-attachment" controls alt={attachmentUrl.at_name}>
                            <source src={attachmentUrl.at_url} />
                        </audio>}
                    {attachmentUrl.type === "video" &&
                        <video id="video-attachment" controls alt={attachmentUrl.at_name} poster={thumbnailUrl.th_url} filename={attachmentUrl.at_name}>
                            <source src={attachmentUrl.at_url} />
                        </video>
                    }
                </>
            }



            {(thumbnailUrl.th_state && attachmentUrl.type !== 'md') && <Chip variant="outlined" color='error' label={thumbnailUrl.th_state && attachmentUrl.at_state ? 'Remove Thumbnail' : 'Remove Attachment'} onClick={deleteThumbnail} onDelete={deleteThumbnail} deleteIcon={<DeleteIcon />} />}
            {(attachmentUrl.at_state && attachmentUrl.type !== 'md') && <Chip variant="outlined" color='error' label="Remove Attachment" onClick={deleteAttachment} onDelete={deleteAttachment} deleteIcon={<DeleteIcon />} />}

        </div>
    );
}

export default AttachmentPreview;